export type {YfmStaticViewProps} from './YfmStaticView';
export {YfmStaticView} from './YfmStaticView';
